var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("tr", [
    _c(
      "td",
      { staticClass: "kpi-performance-table__endColGroup h-left-align" },
      [_vm._v(_vm._s(_vm.name))]
    ),
    _c("td", [_vm._v(_vm._s(_vm.actualValue))]),
    _c("td", [_vm._v(_vm._s(_vm.targetValue))]),
    _c("td", [_vm._v(_vm._s(_vm.previousValue))]),
    _c("td", { class: _vm.targetVarianceClass }, [
      _vm._v(_vm._s(_vm.targetValueDiff))
    ]),
    _c(
      "td",
      {
        staticClass: "kpi-performance-table__endColGroup h-center-align",
        class: _vm.previousYearVarianceClass
      },
      [_vm._v(_vm._s(_vm.previousYearValueDiff))]
    ),
    _c("td", [_vm._v(_vm._s(_vm.actualYtd))]),
    _c("td", [_vm._v(_vm._s(_vm.targetYtd))]),
    _c("td", [_vm._v(_vm._s(_vm.previousYtd))]),
    _c("td", { class: _vm.targetYtdVarianceClass }, [
      _vm._v(_vm._s(_vm.targetYtdValueDiff))
    ]),
    _c(
      "td",
      {
        class:
          "kpi-performance-table__endColGroup h-center-align " +
          _vm.previousYtdVarianceClass
      },
      [_vm._v(_vm._s(_vm.previousYtdValueDiff))]
    ),
    _c(
      "td",
      { class: "kpi-performance-table__comments comments_" + _vm.field },
      [
        _c(
          "div",
          {
            directives: [
              {
                name: "tooltip",
                rawName: "v-tooltip",
                value: { content: _vm.comment, html: true },
                expression: "{ content:comment, html:true }"
              }
            ]
          },
          [_vm._v(_vm._s(_vm.commentShort))]
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }